import * as constants from '../constants/location';

const initialState = {
    currentLocation: null,
    locatables: {}
};

export function reducer(state = initialState, action) {
    let newState = Object.assign({}, state);
    let newLocatables = Object.assign({}, state.locatables);
    switch (action.type) {
        case constants.SET_LOCATABLE:
            // Check if we should update locatables (must be new or updated)
            if (!state.locatables[action.locatable.Id] ||
                (state.locatables[action.locatable.Id] &&
                 !state.locatables[action.locatable.Id].isEqual(action.locatable))) {

                newLocatables[action.locatable.Id] = action.locatable;
                newState.locatables = newLocatables;
                
                return newState;
            } else {
                return state;
            }

        case constants.REMOVE_LOCATABLE:
            delete newLocatables[action.locatable.Id];
            newState.locatables = newLocatables;
            return newState;

        default:
            return newState;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/location.js